import { render, staticRenderFns } from "./AutorizacionGrid.vue?vue&type=template&id=8759e63a&scoped=true&"
import script from "./AutorizacionGrid.vue?vue&type=script&lang=js&"
export * from "./AutorizacionGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8759e63a",
  null
  
)

/* custom blocks */
import block0 from "./AutorizacionGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports